import { bookingConfigLoaded, bookingConfigRequested } from "../Redux/BookingGlobalActions";
import { globalErrorCondition } from "../../../Helpers/ErrorHelper";
import { startOfDay } from "date-fns";
import { dateFromState } from "../../../Helpers/DateTimeHelper";
import { BOOKINGS_API_URL } from "../Bookings";


/**
 * @param amenityUrl    Url for the amenity. Will be in the format: 'categrySlug/amenitySlug'
 * @param date
 * @param boundary
 * @param unitId
 * @param editingThisBookingId
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const getBookingConfigForAmenitySummary = (
    amenityUrl,
    date,
    boundary,
    unitId,
    editingThisBookingId = null
) => async (dispatch, getState) => {
    try {
        // TODO - encapsulate out common code when I figure out how to do it
        dispatch( bookingConfigRequested() );

        if (!boundary) {
            boundary = {
                'start': startOfDay(dateFromState(date)),
                'end': null, // Leaving this null will cause the server to return two days of availability
            };
        }

        const result = await axios.get(`${BOOKINGS_API_URL}categories/${amenityUrl}`, {
            params: {
                date: date,
                boundaryStart: boundary.start,
                boundaryEnd: boundary.end,
                unitId: unitId,
                editingThisBookingId: editingThisBookingId
            }
        });

        return result.data;

    } catch (error) {
        globalErrorCondition('Error loading booking amenity data', error);
    } finally {
    }
}


/**
 * @param categoryId
 * @param amenityId
 * @param date
 * @param boundary
 * @param unitId
 * @param editingThisBookingId
 * @returns {(function(*, *): Promise<void>)|*}
 */
export const getBookingConfig = (
    categoryId,
    amenityId,
    unitId,
    date,
    boundary = null,
    editingThisBookingId = null
) => async (dispatch, getState) => {
    try {
        // TODO - encapsulate out common code when I figure out how to do it
        dispatch( bookingConfigRequested() );

        if (!boundary) {
            boundary = {
                'start': startOfDay(dateFromState(date)),
                'end': null, // Leaving this null will cause the server to return two days of availability
            };
        }

        const result = await axios.get(`${BOOKINGS_API_URL}config`, {
            params: {
                category_id: categoryId,
                amenity_id: amenityId,
                unit_id: unitId,
                date: date,
                boundary_start: boundary.start,
                boundary_end: boundary.end,
                editing_this_booking_id: editingThisBookingId
            }
        });

        dispatch( bookingConfigLoaded() );

        return result.data;

    } catch (error) {
        globalErrorCondition('Error loading booking amenity data', error);
    } finally {
    }
}

